document.querySelectorAll('.InputStars').forEach((el) => {
    const inputs = el.querySelectorAll('input');

    inputs.forEach((input) => {
        input.addEventListener('input', update);
    });

    function update() {
        inputs.forEach((input) => {
            input.parentElement.classList.toggle('InputStars__item--active', input.checked);
        })
    }
})
